import "../base.js";

window.AppointmentBooking ??= {};
window.AppointmentBooking.SlotPickerModal ??= {};
window.AppointmentBooking.SlotPickerModal.Views ??= {};
window.AppointmentBooking.SlotPickerModal.Views.Calendar ??= {};

AppointmentBooking.SlotPickerModal.Views.Calendar.Slots = class Slots extends (
  AppointmentBooking.SlotPickerModal.Views.Base
) {
  constructor() {
    super(...arguments);
    this.initialize = this.initialize.bind(this);
    this.triggerSlotAction = this.triggerSlotAction.bind(this);
    this.contextForRender = this.contextForRender.bind(this);
  }

  initialize(options = {}) {
    this.options = options;
    super.initialize(options);

    // BEHAVIOUR

    return this.listenTo(this.collection, "reset", this.render);
  }

  // EVENT HANDLERS

  handleSlotClick(e) {
    return this.triggerSlotAction(e);
  }

  triggerSlotAction(e) {
    const slot = this.collection.get(jQuery(e.target).data("slot-id"));
    return jQuery(e.target).trigger(AppointmentBooking.SlotPickerModal.Events.slotPick, slot);
  }

  // RENDERING

  contextForRender() {
    const context = super.contextForRender();
    context.slots = this.collection.toJSON();
    context.renderLinks = this.options.renderLinks ?? true;
    return context;
  }
};
AppointmentBooking.SlotPickerModal.Views.Calendar.Slots.prototype.tagName = "tr";
AppointmentBooking.SlotPickerModal.Views.Calendar.Slots.prototype.className =
  "appointment-booking-slot-picker-modal-calendar-slots";
AppointmentBooking.SlotPickerModal.Views.Calendar.Slots.prototype.template =
  "appointment_booking/slot_picker_modal/templates/calendar/slots";
AppointmentBooking.SlotPickerModal.Views.Calendar.Slots.prototype.events = {
  "click [data-slot-id]": "handleSlotClick",
};
